import type { CreateEventStage } from '@libs/CreateEvent/CreateEventStage'
import { CreateEventStageInfo } from '@libs/CreateEventContext'
import { useTheme } from '@libs/useTheme'
import { Fragment } from 'react'

type GenericSteppedFlow = {
  stage: string
}

export type MiniNavInput = CreateEventStageInfo | GenericSteppedFlow

const MiniNav = ({
  className,
  navItems,
  stage,
  disabled,
  setStage,
}: {
  className?: string
  navItems: {
    label: string
    targetStage: CreateEventStage | string | number
  }[]
  stage?: MiniNavInput
  disabled?: boolean
  setStage: (data: Partial<MiniNavInput>) => void,
}) => {
  const selectedIndex = navItems.findIndex(
    (items) => items.targetStage === stage?.stage
  )

  const { theme } = useTheme()
  const isLight = theme.type === 'LIGHT'
  return (
    <div
      className={`flex items-center my-6 py-2 pb-6 cursor-pointer ${navItems.length < 2 ? 'justify-center' : ''} ${className ?? 'sm:pl-[35%] sm:pr-[35%] mt-20'}`}
    >
      {navItems
        .filter((i) =>
          !!stage &&
          (stage as CreateEventStageInfo)?.skipPreview &&
          i.label === 'Preview'
            ? false
            : true
        )
        .map((item, index, items) => {
          const isHighlighted = index <= selectedIndex
          const isActive = index === selectedIndex
          const { label, targetStage } = item
          const offTextColor = isLight ? 'text-black' : 'text-white'

          return (
            <Fragment key={`mininav-item-${item.label}`}>
              <div
                className={`flex flex-col items-center`}
                onClick={() => {
                  if (!disabled && !isActive) {
                    setStage({ stage: targetStage })
                  }
                }}
              >
                <div
                  className={`
                  w-9 h-9 rounded-full flex items-center justify-center text-xs
                  ${
                    isHighlighted
                      ? 'bg-forumm-blue-light text-black'
                      : 'border border-forumm-gray ' + offTextColor
                  }
                  ${isActive ? 'outer-circle' : ''}
                `}
                >
                  {index + 1}
                </div>
                <span className="absolute text-xs mt-11 text-center">
                  {isActive
                    ? label
                    : label
                        .split(' ')
                        .map((name, i) => (i > 0 ? name.slice(0, 1) : name))
                        .join(' .')}
                </span>
              </div>
              {index < items.length - 1 && (
                <div
                  className={`flex-1 ${
                    index < selectedIndex
                      ? 'bg-forumm-blue-light'
                      : 'bg-forumm-gray'
                  } h-px`}
                ></div>
              )}
            </Fragment>
          )
        })}
    </div>
  )
}

export default MiniNav
